import React from 'react'
import {
  createGenericSelectContentEvent,
  trackGAEvent,
} from '@moonpig/web-core-analytics'
import { IconSystemTwinkle } from '@moonpig/launchpad-assets'
import { StyledConciergeButton } from './styled'
import { useLocaleText } from '../locale'

type ConciergeButtonProps = {
  className?: string
}

export const ConciergeButton = ({ className }: ConciergeButtonProps) => {
  const t = useLocaleText()
  const CONCIERGE_VISIBILITY_CHANGE_EVENT = 'concierge-visibility-change'

  const handleConciergeBtnClick = () => {
    trackGAEvent(
      createGenericSelectContentEvent({
        eventCategory: 'navigation',
        eventAction: 'icon',
        eventLabel: 'ai concierge',
      }),
    )

    window.dispatchEvent(
      new CustomEvent(CONCIERGE_VISIBILITY_CHANGE_EVENT, {
        detail: { isOpen: true },
      }),
    )
  }

  return (
    <StyledConciergeButton
      data-testid="concierge-button"
      leadingIcon={<IconSystemTwinkle />}
      onClick={e => {
        e.preventDefault()
        handleConciergeBtnClick()
      }}
      className={className}
    >
      {t('search.concierge_btn')}
    </StyledConciergeButton>
  )
}
